module.exports = __webpack_public_path__ + "static/ARTS_IMAGE_2-aa783a91f8b8552ef94a367c1653dcd4.jpg";